<template>
  <input-widget
    id="idSellAnItemReserveInput"
    type="number"
    v-model="model"
    :rules="required ? 'required' : ''"
    :label="$t('SELL_AN_ITEM.Reserve')"
    :error="sellAnItemModal.errors.reserve"
    @change="onChange"
  />
</template>

<script>
import {mapMutations, mapState} from "vuex";
import InputWidget from "@/components/core/InputWidget.vue";
import baseInputMixin from "@/components/sell-an-item-modal/baseInputMixin";

export default {
  name: "ReserveInput",
  components: {InputWidget},
  mixins: [baseInputMixin('', 'reserve')],
  computed: {
    ...mapState(['sellAnItemModal'])
  },
  methods: {
    ...mapMutations(['setSellAnItemModalFieldInput', 'resetSellAnItemErrors']),
    onChange(val) {
      if (val)
        this.resetSellAnItemErrors('reserve')
      this.setSellAnItemModalFieldInput({field: 'reserve', value: val})
    }
  }
}
</script>

<style scoped>

</style>
